let lastNotifyTime = 0

export function desktopNotify({
    title = '系统通知',
    body = '',
    icon = '/favicon.ico',
    onClick,
    gap = 3000 // 防刷间隔
} = {}) {
    // 1. 浏览器能力检测
    if (!('Notification' in window)) return

    const now = Date.now()
    if (now - lastNotifyTime < gap) return
    lastNotifyTime = now

    // 2. 已授权
    if (Notification.permission === 'granted') {
        const notify = new Notification(title, {
            body,
            icon,
            silent: false
        })

        notify.onclick = () => {
            window.focus()
            notify.close()
            onClick && onClick()
        }
        return
    }

    // 3. 首次请求授权
    if (Notification.permission === 'default') {
        Notification.requestPermission().then(res => {
            if (res === 'granted') {
                desktopNotify({ title, body, icon, onClick })
            }
        })
    }
}
